import script from "./VehicleTypesList.vue?vue&type=script&setup=true&lang=ts"
export * from "./VehicleTypesList.vue?vue&type=script&setup=true&lang=ts"

import "./VehicleTypesList.vue?vue&type=style&index=0&id=2d3460c6&lang=sass&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d3460c6"]])

export default __exports__